import * as Generated from './generated/AnalyticsBeacons'

// Alias the really long namespaces then re-export them in more consumable forms
// These are pretty common structs.
import ApplicationID = Generated.com.flipp.beacon.common.enumeration.ApplicationID
import Base = Generated.com.flipp.beacon.common.entity.Base
import Budget = Generated.com.flipp.beacon.common.entity.Budget
import Publisher = Generated.com.flipp.beacon.common.entity.Publisher
import SchemaInfo = Generated.com.flipp.beacon.common.entity.SchemaInfo
import Flyer = Generated.com.flipp.beacon.common.entity.Flyer
import Merchant = Generated.com.flipp.beacon.common.entity.Merchant
import FlyerItem = Generated.com.flipp.beacon.common.entity.FlyerItem
import UserAccount = Generated.com.flipp.beacon.common.entity.UserAccount

const schemaNames = {
    [Generated.HeroPostClosePostSchemaId]: 'HeroPostClosePost',
    [Generated.HeroPostFlyerEngagedVisitFlyerSchemaId]:
        'HeroPostFlyerEngagedVisitFlyer',
    [Generated.HeroPostOpenFlyerSchemaId]: 'HeroPostOpenFlyer',
    [Generated.HeroPostFlyerViewFlyerSchemaId]: 'HeroPostFlyerViewFlyer',
    [Generated.HeroPostFlyerClickFlyerItemSchemaId]:
        'HeroPostFlyerClickFlyerItem',
    [Generated.HeroPostOpenPostExperienceSchemaId]:
        'HeroPostOpenPostExperience',

    [Generated.BrowseAdAdaptedImpressionAdSchemaId]:
        'BrowseAdAdaptedImpressionAd',
    [Generated.BrowseAdAdaptedViewableImpressionAdSchemaId]:
        'BrowseAdAdaptedViewableImpressionAd',
    [Generated.BrowseAdAdaptedOpenAddToCartAdSchemaId]:
        'BrowseAdAdaptedOpenAddToCartAd',
    [Generated.BrowseAdAdaptedOpenAddToShoppingListAdSchemaId]:
        'BrowseAdAdaptedOpenAddToShoppingListAd',
}

export {
    ApplicationID,
    Base,
    Budget,
    Publisher,
    Flyer,
    FlyerItem,
    Merchant,
    SchemaInfo,
    UserAccount,
    schemaNames,
}
